// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ss-filters {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: 0.65rem;
  padding: 0.85rem 1.5rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--border, #e2e8f0);
}

.ss-filters__search {
  min-width: 220px;
  flex: 1 1 220px;
  max-width: 320px;
}

.ss-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
}

.ss-chips--currency {
  margin: 0 0 1rem;
}

.ss-chip,
.ss-tab {
  font-family: inherit;
  font-size: 0.82rem;
  font-weight: 700;
  padding: 0.4rem 0.85rem;
  border-radius: 999px;
  border: 1px solid #dbe2ea;
  background: #fff;
  color: #334155;
  cursor: pointer;
}

.ss-chip--active,
.ss-tab--active {
  color: #fff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
}

.ss-table td,
.ss-table th {
  vertical-align: top;
}

.ss-row {
  cursor: pointer;
}

.ss-row:hover {
  background: #f0fdfa;
}

.ss-row--nested td {
  background: #f8fafc;
}

.ss-user-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 0.3rem;
}

.ss-paused-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.12rem 0.45rem;
  border-radius: 999px;
  background: #fef2f2;
  color: #b91c1c;
  font-size: 0.68rem;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.ss-copy-cell {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.ss-copy-cell code,
.ss-mini-id {
  font-size: 0.78rem;
  background: #f1f5f9;
  padding: 0.12rem 0.35rem;
  border-radius: 4px;
}

.ss-copy-btn,
.ss-uuid-btn {
  border: 0;
  background: transparent;
  color: #0f766e;
  cursor: pointer;
  padding: 0.15rem;
}

.ss-uuid-btn {
  font: inherit;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.ss-ccy {
  font-weight: 700;
}

.ss-amt--paid {
  color: #166534;
  font-weight: 700;
}

.ss-amt--remain {
  color: #c2410c;
  font-weight: 700;
}

.ss-amt--forfeit {
  color: #b91c1c;
  font-weight: 700;
}

.ss-pagination {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
  padding: 0.85rem 1.5rem 1.1rem;
}

.ss-empty,
.ss-error-banner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.65rem;
  padding: 2rem 1rem;
  color: #64748b;
  text-align: center;
}

.ss-empty i,
.ss-error-banner i {
  font-size: 1.6rem;
  color: #94a3b8;
}

.ss-error-banner {
  background: rgba(220, 38, 38, 0.06);
  color: #b91c1c;
}

.ss-detail-toolbar {
  margin-bottom: 1rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.ss-back-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  padding: 0.45rem 0.9rem;
  font-size: 0.86rem;
  font-weight: 600;
  font-family: inherit;
  color: #0f766e;
  background: #fff;
  border: 1px solid rgba(15, 118, 110, 0.35);
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
}

.ss-back-btn:hover {
  background: #f0fdfa;
}

.ss-user-head {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  background: #fff;
  border: 1px solid var(--border, #e2e8f0);
  border-radius: 12px;
  padding: 1rem 1.15rem;
  margin-bottom: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ss-user-head h2 {
  margin: 0 0 0.4rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1.25rem;
}

.ss-user-head p {
  margin: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  color: #64748b;
  font-size: 0.88rem;
}

.ss-user-head__plans {
  font-size: 0.88rem;
  color: #475569;
}

.ss-tabs {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  margin: 0 0 1rem;
}

.ss-cards {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 0.85rem;
  margin-bottom: 1rem;
}

.ss-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.9rem 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ss-card__head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.4rem;
  font-size: 0.78rem;
  color: #64748b;
  font-weight: 700;
}

.ss-card strong {
  display: block;
  margin: 0.35rem 0 0.15rem;
  font-size: 1.05rem;
  color: #0f172a;
  font-variant-numeric: tabular-nums;
}

.ss-card small {
  color: #64748b;
  font-size: 0.72rem;
}

.ss-card--grey {
  background: #f8fafc;
}

.ss-card--green {
  border-color: #bbf7d0;
  background: #f0fdf4;
}

.ss-card--orange {
  border-color: #fed7aa;
  background: #fff7ed;
}

.ss-card--red {
  border-color: #fecaca;
  background: #fef2f2;
}

.ss-help {
  color: #94a3b8;
  font-size: 0.72rem;
  cursor: help;
}

.ss-progress-wrap {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 0.85rem;
  margin-bottom: 0.85rem;
}

.ss-progress {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.85rem 1rem;
}

.ss-progress__meta {
  display: flex;
  justify-content: space-between;
  font-size: 0.78rem;
  color: #475569;
  margin-bottom: 0.4rem;
}

.ss-progress__track {
  height: 8px;
  border-radius: 999px;
  background: #e2e8f0;
  overflow: hidden;
}

.ss-progress__fill {
  height: 100%;
  background: linear-gradient(90deg, #0f766e, #14b8a6);
}

.ss-note {
  font-size: 0.8rem;
  color: #64748b;
  margin: 0 0 1rem;
}

.ss-plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 1rem;
}

.ss-plan-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 1rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.ss-plan-card__head {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  align-items: flex-start;
  margin-bottom: 0.85rem;
}

.ss-plan-card__badges {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
  margin-top: 0.4rem;
}

.ss-plan-dl {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 0.65rem 0.85rem;
  margin: 0;
}

.ss-plan-dl dt {
  font-size: 0.72rem;
  color: #64748b;
  font-weight: 700;
}

.ss-plan-dl dd {
  margin: 0.15rem 0 0;
  font-size: 0.86rem;
  color: #0f172a;
}

.ss-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.5rem;
  border-radius: 999px;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: capitalize;
}

.ss-badge--grey {
  background: #f1f5f9;
  color: #475569;
}

.ss-badge--green {
  background: #dcfce7;
  color: #166534;
}

.ss-badge--orange {
  background: #ffedd5;
  color: #c2410c;
}

.ss-badge--red {
  background: #fee2e2;
  color: #b91c1c;
}

.ss-badge--blue {
  background: #dbeafe;
  color: #1d4ed8;
}

.ss-ledger-controls {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 0.85rem;
}

.ss-toggle {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  font-size: 0.86rem;
  font-weight: 700;
  color: #334155;
}

.ss-ledger td,
.ss-ledger th {
  font-variant-numeric: tabular-nums;
}

.ss-ledger__row--pending {
  opacity: 0.72;
  background: repeating-linear-gradient(
    -45deg,
    #fff,
    #fff 8px,
    #fff7ed 8px,
    #fff7ed 16px
  );
}

.ss-ledger__row--pending td {
  border-top: 1px dashed #fdba74;
}

.ss-ledger__hint {
  display: block;
  margin-top: 0.2rem;
  color: #64748b;
  font-size: 0.72rem;
}

@media (max-width: 768px) {
  .ss-user-head,
  .ss-plan-card__head {
    flex-direction: column;
  }

  .ss-plan-dl {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Staking/StakingStatementPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,eAAe;EACf,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,yBAAyB;EACzB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;;EAEE,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;;EAEE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8BAA8B;AAChC;;AAEA;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;EACd,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,wCAAwC;EACxC,mBAAmB;EACnB,qBAAqB;EACrB,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,aAAa;EACb,eAAe;EACf,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,kCAAkC;AACpC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oDAAoD;AACtD;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb;;;;;;GAMC;AACH;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE;;IAEE,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".ss-filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: flex-end;\n  gap: 0.65rem;\n  padding: 0.85rem 1.5rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--border, #e2e8f0);\n}\n\n.ss-filters__search {\n  min-width: 220px;\n  flex: 1 1 220px;\n  max-width: 320px;\n}\n\n.ss-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n}\n\n.ss-chips--currency {\n  margin: 0 0 1rem;\n}\n\n.ss-chip,\n.ss-tab {\n  font-family: inherit;\n  font-size: 0.82rem;\n  font-weight: 700;\n  padding: 0.4rem 0.85rem;\n  border-radius: 999px;\n  border: 1px solid #dbe2ea;\n  background: #fff;\n  color: #334155;\n  cursor: pointer;\n}\n\n.ss-chip--active,\n.ss-tab--active {\n  color: #fff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n}\n\n.ss-table td,\n.ss-table th {\n  vertical-align: top;\n}\n\n.ss-row {\n  cursor: pointer;\n}\n\n.ss-row:hover {\n  background: #f0fdfa;\n}\n\n.ss-row--nested td {\n  background: #f8fafc;\n}\n\n.ss-user-cell {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 0.3rem;\n}\n\n.ss-paused-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.12rem 0.45rem;\n  border-radius: 999px;\n  background: #fef2f2;\n  color: #b91c1c;\n  font-size: 0.68rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n}\n\n.ss-copy-cell {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.ss-copy-cell code,\n.ss-mini-id {\n  font-size: 0.78rem;\n  background: #f1f5f9;\n  padding: 0.12rem 0.35rem;\n  border-radius: 4px;\n}\n\n.ss-copy-btn,\n.ss-uuid-btn {\n  border: 0;\n  background: transparent;\n  color: #0f766e;\n  cursor: pointer;\n  padding: 0.15rem;\n}\n\n.ss-uuid-btn {\n  font: inherit;\n  font-weight: 700;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.ss-ccy {\n  font-weight: 700;\n}\n\n.ss-amt--paid {\n  color: #166534;\n  font-weight: 700;\n}\n\n.ss-amt--remain {\n  color: #c2410c;\n  font-weight: 700;\n}\n\n.ss-amt--forfeit {\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.ss-pagination {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n  padding: 0.85rem 1.5rem 1.1rem;\n}\n\n.ss-empty,\n.ss-error-banner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.65rem;\n  padding: 2rem 1rem;\n  color: #64748b;\n  text-align: center;\n}\n\n.ss-empty i,\n.ss-error-banner i {\n  font-size: 1.6rem;\n  color: #94a3b8;\n}\n\n.ss-error-banner {\n  background: rgba(220, 38, 38, 0.06);\n  color: #b91c1c;\n}\n\n.ss-detail-toolbar {\n  margin-bottom: 1rem;\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.ss-back-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  padding: 0.45rem 0.9rem;\n  font-size: 0.86rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid rgba(15, 118, 110, 0.35);\n  border-radius: 8px;\n  text-decoration: none;\n  cursor: pointer;\n}\n\n.ss-back-btn:hover {\n  background: #f0fdfa;\n}\n\n.ss-user-head {\n  display: flex;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  background: #fff;\n  border: 1px solid var(--border, #e2e8f0);\n  border-radius: 12px;\n  padding: 1rem 1.15rem;\n  margin-bottom: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.ss-user-head h2 {\n  margin: 0 0 0.4rem;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1.25rem;\n}\n\n.ss-user-head p {\n  margin: 0;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  color: #64748b;\n  font-size: 0.88rem;\n}\n\n.ss-user-head__plans {\n  font-size: 0.88rem;\n  color: #475569;\n}\n\n.ss-tabs {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n  margin: 0 0 1rem;\n}\n\n.ss-cards {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 1rem;\n}\n\n.ss-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.9rem 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.ss-card__head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.4rem;\n  font-size: 0.78rem;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.ss-card strong {\n  display: block;\n  margin: 0.35rem 0 0.15rem;\n  font-size: 1.05rem;\n  color: #0f172a;\n  font-variant-numeric: tabular-nums;\n}\n\n.ss-card small {\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.ss-card--grey {\n  background: #f8fafc;\n}\n\n.ss-card--green {\n  border-color: #bbf7d0;\n  background: #f0fdf4;\n}\n\n.ss-card--orange {\n  border-color: #fed7aa;\n  background: #fff7ed;\n}\n\n.ss-card--red {\n  border-color: #fecaca;\n  background: #fef2f2;\n}\n\n.ss-help {\n  color: #94a3b8;\n  font-size: 0.72rem;\n  cursor: help;\n}\n\n.ss-progress-wrap {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 0.85rem;\n  margin-bottom: 0.85rem;\n}\n\n.ss-progress {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.85rem 1rem;\n}\n\n.ss-progress__meta {\n  display: flex;\n  justify-content: space-between;\n  font-size: 0.78rem;\n  color: #475569;\n  margin-bottom: 0.4rem;\n}\n\n.ss-progress__track {\n  height: 8px;\n  border-radius: 999px;\n  background: #e2e8f0;\n  overflow: hidden;\n}\n\n.ss-progress__fill {\n  height: 100%;\n  background: linear-gradient(90deg, #0f766e, #14b8a6);\n}\n\n.ss-note {\n  font-size: 0.8rem;\n  color: #64748b;\n  margin: 0 0 1rem;\n}\n\n.ss-plan-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));\n  gap: 1rem;\n}\n\n.ss-plan-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 1rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.ss-plan-card__head {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  align-items: flex-start;\n  margin-bottom: 0.85rem;\n}\n\n.ss-plan-card__badges {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n  margin-top: 0.4rem;\n}\n\n.ss-plan-dl {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 0.65rem 0.85rem;\n  margin: 0;\n}\n\n.ss-plan-dl dt {\n  font-size: 0.72rem;\n  color: #64748b;\n  font-weight: 700;\n}\n\n.ss-plan-dl dd {\n  margin: 0.15rem 0 0;\n  font-size: 0.86rem;\n  color: #0f172a;\n}\n\n.ss-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.18rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: capitalize;\n}\n\n.ss-badge--grey {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.ss-badge--green {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.ss-badge--orange {\n  background: #ffedd5;\n  color: #c2410c;\n}\n\n.ss-badge--red {\n  background: #fee2e2;\n  color: #b91c1c;\n}\n\n.ss-badge--blue {\n  background: #dbeafe;\n  color: #1d4ed8;\n}\n\n.ss-ledger-controls {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  margin-bottom: 0.85rem;\n}\n\n.ss-toggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  font-size: 0.86rem;\n  font-weight: 700;\n  color: #334155;\n}\n\n.ss-ledger td,\n.ss-ledger th {\n  font-variant-numeric: tabular-nums;\n}\n\n.ss-ledger__row--pending {\n  opacity: 0.72;\n  background: repeating-linear-gradient(\n    -45deg,\n    #fff,\n    #fff 8px,\n    #fff7ed 8px,\n    #fff7ed 16px\n  );\n}\n\n.ss-ledger__row--pending td {\n  border-top: 1px dashed #fdba74;\n}\n\n.ss-ledger__hint {\n  display: block;\n  margin-top: 0.2rem;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n@media (max-width: 768px) {\n  .ss-user-head,\n  .ss-plan-card__head {\n    flex-direction: column;\n  }\n\n  .ss-plan-dl {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
